import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  title: string
}
export const AgreementQuestionnaireCollapsable = ({
  title,
  children,
}: React.PropsWithChildren<Props>) => {
  const [openSection, setOpenSection] = React.useState(false)

  return (
    <Box
      paddingBottom="s24"
      gap="s12"
      border={{
        bottom: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
    >
      <Box flexDirection="row" justifyContent="spaceBetween" width="full">
        <Text.Header2 weight="semibold">{title}</Text.Header2>
        <Button
          onClick={() => setOpenSection(!openSection)}
          type="secondary"
          iconName={openSection ? 'chevron-up' : 'chevron-down'}
          aria-label={
            openSection
              ? i18n.t('performance_process.agreements.sections.hide_label')
              : i18n.t('performance_process.agreements.sections.show_label', {
                  section_title: title,
                })
          }
        />
      </Box>

      {openSection && children}
    </Box>
  )
}
